import {
  IClubApplicationDto,
  ICreateClubApplicationDto,
  IUpdateClubApplicationDto,
} from "../common/interfaces/club-application.interface";
import {
  APPLICATIONS_URL,
  DEPOSITS,
  USERS_BASE_URL,
} from "./utilities/app.urls";

import { get, patch, post } from "./utilities/http";

/**
 * Get all club applications
 * @return {Promise<IClubApplicationDto>}
 */
export function getAllApplications(
  clubAddress: string
): Promise<IClubApplicationDto[]> {
  return get(`${APPLICATIONS_URL}/${clubAddress}`);
}

/**
 * Get user application for club
 * @return {Promise<IClubApplicationDto>}
 */
export function getUsersApplication(
  clubAddress: string,
  userAddress: string
): Promise<IClubApplicationDto> {
  return get(`${USERS_BASE_URL}/${userAddress}/${clubAddress}`);
}

/**
 * Create new application
 * @return {Promise<any>}
 */
export function createApplication(
  data: ICreateClubApplicationDto
): Promise<any> {
  return post(APPLICATIONS_URL, data);
}

/**
 * Update application status
 * @return {Promise<any>}
 */
export function updateApplication(
  data: IUpdateClubApplicationDto,
  applicationId: string
): Promise<any> {
  return patch(`${APPLICATIONS_URL}/${applicationId}`, data);
}

/**
 *
 * @param clubAddress Address of club whose applications should be fetched
 * @returns
 */
export function getApplicationsWithDepositsForClub(clubAddress: string) {
  return get(`${APPLICATIONS_URL}/${DEPOSITS}/${clubAddress}`);
}
